import { config } from "../config";

/**
 * Get the base URL for the QPilot Recipes API
 * Uses the standard backend host - recipes endpoints are at /recipes/*
 *
 * @returns {string} The API base URL
 */
export function getRecipesApiUrl() {
    return config.REACT_APP_BACKEND_HOST;
}
